import styled from "styled-components";
export const FieldContent = styled.div `
  position: relative;
  min-width: 0;
  flex-grow: 1;
`;
